import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
export const RELATIVE_URL = 'notifications';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'name',
  'type',
  'seen',
  'message',  
  'createdAt', 
  'actions',
];

export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'Usuário',
    class: 'soluction-name-column text-center', 
    headerClass: 'soluction-name-header-column text-center', 
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'Tipo',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'seen',
    display: 'Visto',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'message',
    display: 'Mensagem',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column text-center`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} responsive-column`,
  },

];

